













import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "../common/AsiCardDetail.vue";
import Company from "@/models/company/Company";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import {formatCurrency} from "@/helpers/functions_asi";
import CompanyUpdateDialogRates from "@/components/company/CompanyUpdateDialogRates.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {CompanyUpdateDialogRates, AsiCardDetailEntry, AsiCardDetail}
})
export default class CompanyCardRates extends Vue {

	@Prop({type: Object, default: null})
	public company!: Company | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	@Emit('companyChanged')
	public companyChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

	private formatCurrencyAmount(amount: number | null): string | null {
		return formatCurrency(amount);
	}

}
